module.exports = __webpack_public_path__ + "images/ciudad_desktop.b4281554.png";